/** Сегменты пути библиотеки в БД иногда содержат UUID вместо названий — не показываем их в UI. */
const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function libraryPathToBreadcrumbTitles(path: string): string[] {
  return path
    .split('/')
    .map((s) => s.trim())
    .filter(Boolean)
    .filter((s) => !UUID_SEGMENT.test(s));
}
